import { useState } from 'react'
import ResourceList from '../../../components/admin/ResourceList'
import SectionContainer from '../../../components/common/SectionContainer'
import InlineStack from '../../../components/common/InlineStack'
import ActionsDropdown from '../../../components/common/ActionsDropdown'
import InputModalContent from '../../../components/common/InputModalContent'
import useModal from '../../../common/hooks/useModal'
import fetchAPI from '../../../common/fetchAPI'
import { formatDateTime } from '../../../common/helpers'
import BlockStack from '../../../components/common/BlockStack'

export default function SitesList({ enablePullToRefresh }) {
    const { setModal, setModalLoading, isModalLoading } = useModal()
    const [key, setKey] = useState(Date.now())

    function openApiKeyModal() {
        setModal(
            <InputModalContent
                label="Enter Netlify API Key"
                type="text"
                confirmText="Save"
                onConfirm={async function handleNetlifyApiKeyConfirm(
                    { text },
                    setError,
                ) {
                    setError('')
                    if (isModalLoading) return
                    setModalLoading(true)
                    const { error } = await fetchAPI(
                        '/v1/settings/netlifyApiKey',
                        { settingValue: text },
                        'PATCH',
                    )
                    setModalLoading(false)

                    if (error) {
                        setError(error)
                        return
                    }

                    setKey(Date.now())
                    setModal(null)
                }}
            />,
            'API Key Input',
        )
    }

    const actions = [
        {
            title: 'Netlify API Key',
            onClick: openApiKeyModal,
        },
    ]

    return (
        <>
            <SectionContainer>
                <header className="info-header">
                    <InlineStack spaceBetween gap="sm">
                        <h2>Sites</h2>
                        <ActionsDropdown actions={actions} />
                    </InlineStack>
                </header>
            </SectionContainer>

            <ResourceList
                enablePullToRefresh={enablePullToRefresh}
                paginated
                paginationLimit={20}
                getItemsFromResponse={(data) => data || []}
                apiUrl={'/v1/sites'}
                filters={{
                    search: true,
                }}
                key={key}
                fields={[
                    {
                        column: 1,
                        getValue: (item) => (
                            <BlockStack gap={'sm'}>
                                <div>{item.name}</div>
                                <div className="text-subdued">
                                    {formatDateTime(item.created_at)}
                                </div>
                            </BlockStack>
                        ),
                    },
                ]}
            />
        </>
    )
}
